import React, { ReactElement } from "react";
import Layout from "../../components/layout";
import AddProduct from "../../components/products/AddProduct";
import MultipleEdit from "../../components/products/MultipleEdit";

const ProductEditMultiple = (): ReactElement => {
  return (
    <Layout>
      <MultipleEdit />
    </Layout>
  );
};

export default ProductEditMultiple;
